import { AppThunk } from '../../../../../store/types';
import { AudioPlayerManager } from '../../../../../effects/audioPlayer/audioPlayerManager';
import { AudioEffects } from '../../../../../effects/audioEffects';
import { getUserStateStorage } from '../../../../../../common/utils/local-storage/user-state';
import { getLibraryGroupId, getPlayerRate } from '../../../../../store/general/selectors';
import { isPageLocked } from '../../../../../store/general/selectors';
import { UserGroupEffects } from '../../../../../effects/userGroupEffects';
import { ShortcutManager } from '../../../../../effects/shortcut/shortcutManager';
import { ESystemHotKeys } from '../../../../../effects/shortcut/types';
import { PlayerController } from '../../../../../effects/player/manager/playerController';
import { Navigator } from '../../../../../effects/navigator';

export class AudioEvents {

  public static onOpenRecordings (): AppThunk {
    return (
      dispatch,
      getState,
    ) => {
      Navigator.openRoot();
    }
  }

  public static onLoad(
    audioId: number,
    groupId: number
  ): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      if (!audioId) return;
      // Only persist the audio to user-state if it actually loaded — otherwise a broken/foreign
      // audio would be restored on the next open.
      if (await AudioEffects.load(audioId, groupId)) {
        getUserStateStorage().setAudioInfo(audioId, groupId);
      }
    }
  }

  public static onUpdateAudioPlayer(
    player: HTMLMediaElement | null | undefined
  ): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      AudioPlayerManager.getInstance().setPlayer(player, getPlayerRate(getState()));
    }
  }

  public static onUpdateGroupId(
    groupId: number
  ): AppThunk {
    return (
      dispatch,
      getState,
    ) => {
      setTimeout(() => {
        const libraryGroupId = getLibraryGroupId(getState());
        if (libraryGroupId !== groupId) { // browser back
          UserGroupEffects.setLibraryGroupId(groupId);
        }
      }, 100);
    }
  }

  public static onKeyUp(event: KeyboardEvent): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const pageLocked = isPageLocked(getState());
      if (!pageLocked) {
        const keyCode = event.code as ESystemHotKeys;
        if (keyCode !== ESystemHotKeys.F) {
          ShortcutManager.keyUp(event);
        }
      }
    }
  }

  public static onKeyDown(event: KeyboardEvent): AppThunk {
    return async (
      dispatch,
      getState
    ) => {
      const pageLocked = isPageLocked(getState());
      if (!pageLocked) {
        ShortcutManager.keyDown(event);
      }
    }
  }

  public static onDocClick (): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      PlayerController.getInstance().pause();
    }
  }

}
